import { createBrowserClient } from '@supabase/ssr'

import { url, key } from './get-credentials'

export function createComponentClient() {
  return createBrowserClient(url as string, key as string)
}
